import React, { useContext } from 'react';
import { BaseAddonCategoryXlsType } from 'utils/types';

type BaseAddonCategoryXlsContextType = {
  addons: any[];
  setAddons: (item: any[]) => void;
  mappedAddons: Partial<BaseAddonCategoryXlsType[]>;
  setMappedAddons: (item: Partial<BaseAddonCategoryXlsType[]>) => void;
  reviewedAddons: string[];
  setReviewedAddons: (item: string[]) => void;
  xlsFile: File | null;
  setXlsFile: (item: File | null) => void;
};

export const BaseAddonCategoryXlsContext = React.createContext(
  {} as BaseAddonCategoryXlsContextType
);

const useBaseAddonCategoryXlsContext = () => {
  const context = useContext(BaseAddonCategoryXlsContext);
  return context;
};

export default useBaseAddonCategoryXlsContext;
